import Component from '@glimmer/component';

interface PreviewBadgeSignature {
  Args: {
    previewSHA: string;
    repo?: string;
    label?: string;
  };
  Element: HTMLAnchorElement;
}

export default class PreviewBadge extends Component<PreviewBadgeSignature> {
  get href(): string {
    return `https://github.com/envoy/${this.args.repo ?? 'garaje'}/commit/${this.args.previewSHA}`;
  }

  <template>
    <a
      href={{this.href}}
      class="flex flex-col items-center justify-center w-[98px] h-7 rounded-lg bg-[#2F86EB] font-bold uppercase text-white no-underline outline-none"
      data-test-preview-badge
    >
      <span class="text-[11px] leading-tight tracking-[0.04em] truncate max-w-full">{{@previewSHA}}</span>
      {{#if @label}}
        <span
          class="text-[8px] leading-tight tracking-[0.05em] font-semibold opacity-75 truncate max-w-full"
        >{{@label}}</span>
      {{/if}}
    </a>
  </template>
}
